































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
  FormItem,
  Option,
  OptionGroup,
  Radio,
  Select,
  RadioButton,
  RadioGroup
} from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import CustomerLocation from '@/components/location/CustomerLocation.vue';

// Types
import {
  InquiryFields,
  InquiryInput,
  PlaceFields,
  TransportationTypeEnum,
  IncotermsTypeEnum,
  CustomerRoleEnum,
  CustomerOrganizationFields
} from '@/types/graphql/schemaTypes';
import { ElAutocomplete, SelectOption } from '@/types/types';

import { createIncoterms } from '@/constants/incoterms';
import { portService } from '@/services/PortService';
import rules from '@/rules/rules';

import get from 'lodash/get';
import { i18n } from '@/plugins/i18n';

@Component({
  components: {
    CustomerLocation,
    UtcDatePicker,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-option-group': OptionGroup,
    'el-radio': Radio,
    'el-select': Select,
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup
  }
})
export default class UpsertRoute extends Vue {
  @Prop({ default: () => ({}) }) inquiry!: InquiryFields;
  @Prop({ default: () => ({}) }) customerOrganization!: CustomerOrganizationFields;
  @Prop({ default: null, type: String }) customerRole!: CustomerRoleEnum | null;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({ default: true }) arrivalValid!: boolean;
  @Prop({ default: true }) departureValid!: boolean;
  @Prop() stepNumber?: number;

  public rules = rules;
  public inquiryInput: InquiryInput = {
    arrivalCustomerLocationId: null,
    arrivalPlaceId: null,
    customerRole: 'seller',
    departureCustomerLocationId: null,
    departurePlaceId: null,
    desiredArrivalDate: null,
    desiredDepartureDate: null,
    incoterm: null,
    transportationType: TransportationTypeEnum.any
  };

  public incotermOptions: SelectOption<any>[] = createIncoterms();

  private departurePlace: PlaceFields | null = null;
  private arrivalPlace: PlaceFields | null = null;

  public created() {
    this.resetInquiryInput();
  }

  @Watch('readOnly')
  resetInquiryInput() {
    this.inquiryInput = {
      arrivalCustomerLocationId: get(this.inquiry, 'arrivalCustomerLocation.id') || null,
      arrivalPlaceId: get(this.inquiry, 'arrivalPlace.id') || null,
      customerRole: this.inquiry.customerRole || 'seller',
      departureCustomerLocationId: get(this.inquiry, 'departureCustomerLocation.id') || null,
      departurePlaceId: get(this.inquiry, 'departurePlace.id') || null,
      desiredArrivalDate: this.inquiry.desiredArrivalDate || null,
      desiredDepartureDate: this.inquiry.desiredDepartureDate || null,
      incoterm: this.inquiry.incoterm || null,
      transportationType: this.inquiry.transportationType || TransportationTypeEnum.any
    };

    this.departurePlace = this.inquiry.departurePlace;
    this.arrivalPlace = this.inquiry.arrivalPlace;
  }

  @Watch('inquiryInput', { deep: true })
  updateParent(input: InquiryInput) {
    if (!this.readOnly) {
      this.$emit('routeUpdated', input);
    }
  }
}
